<template>
  <div class="row">
    <div class="col-sm-7 offset-sm-3">
      <div
        v-loading="isLoading"
        class="sms-conversation-content"
      >
        <div
          v-if="!isPhoneNumberValid"
          class="sms-conversation-empty"
        >
          {{ emptyInvalidMessage }}
        </div>
        <div
          v-else-if="!isLoading && messages.length === 0"
          class="sms-conversation-empty"
        >
          No message history for this number.
        </div>
        <div
          v-for="item in messages"
          :key="item.id"
          class="chat-message"
        >
          <div
            v-dompurify-html="util.convertTextToHtml(item.message ?? '-')"
            class="chat-message-body"
            :class="item.status === 'received' ? 'chat-message-body--caller' : 'chat-message-body--operator'"
          />
          <div
            class="chat-message-time"
            :class="item.status === 'received' ? 'text-left' : 'text-right'"
          >
            {{ util.formatDateTime(item.createdAt, 'MMM D, YYYY h:mm A') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import util from '@/Utils/util';
import type { TextMessage } from '@/models/textMessage';

withDefaults(
  defineProps<{
    messages: TextMessage[];
    isLoading?: boolean;
    isPhoneNumberValid?: boolean;
    emptyInvalidMessage?: string;
  }>(),
  {
    isLoading: false,
    isPhoneNumberValid: false,
    emptyInvalidMessage: 'Enter a valid phone number to load message history.',
  },
);
</script>

<style lang="scss" scoped>
.sms-conversation-content {
  margin: 8px 0;
  max-height: 360px;
  overflow-y: auto;
  padding: 16px;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-sizing: border-box;

  .sms-conversation-empty {
    color: #737373;
    font-size: 13px;
    text-align: center;
    padding: 24px 8px;
  }

  .chat-message {
    display: flex;
    flex-direction: column;
    margin-bottom: 14px;
    font-size: 14px;
    word-break: break-word;

    &:last-child {
      margin-bottom: 0;
    }

    &-body {
      max-width: 70%;
      width: fit-content;
      padding: 8px 12px;
      border-radius: 12px;
      line-height: 1.4;

      &--caller {
        align-self: flex-start;
        color: #0a0a0a;
        background: #fff;
        border: 1px solid #e5e5e5;
      }

      &--operator {
        align-self: flex-end;
        color: #fff;
        background: #0084d1;
      }
    }

    &-time {
      font-size: 11px;
      color: #737373;
      margin-top: 4px;
      padding: 0 2px;
    }
  }
}
</style>
